import { useTranslation } from 'react-i18next';

export const useLanguageUrl = () => {
  const { i18n } = useTranslation();
  
  const getLanguageUrl = (path) => {
    const currentLang = i18n.language || 'fr';
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLang}${cleanPath}`;
  };

  return { getLanguageUrl, currentLanguage: i18n.language || 'fr' };
};

export const getLanguageFromPath = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  return segments[0] && ['en', 'fr'].includes(segments[0]) ? segments[0] : 'fr';
};

export const removeLanguageFromPath = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] && ['en', 'fr'].includes(segments[0])) {
    return '/' + segments.slice(1).join('/');
  }
  return pathname;
};
